import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinner, NgxSpinnerService, NgxSpinnerComponent } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { CustomerService } from '../../_services/customer.service';
import { GoogleAnalyticsService } from '../../_services/google-analytics.service';
import { IShopifyLogin } from '@app/_shared/_models';
import { MatDialogTitle, MatDialogClose } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatError } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    imports: [MatDialogTitle, MatIcon, MatDialogClose, FormsModule, ReactiveFormsModule, MatFormField, MatInput, NgxSpinnerComponent, MatError, MatButton, AsyncPipe]
})
export class LoginComponent implements OnInit {
  private readonly formBuilder = inject(UntypedFormBuilder);
  private readonly customerService = inject(CustomerService);
  private readonly spinnerService = inject(NgxSpinnerService);
  private readonly router = inject(Router);
  private readonly googleAnalyticsService = inject(GoogleAnalyticsService);

  public email = new UntypedFormControl('', [Validators.required, Validators.email]);
  public password = new UntypedFormControl('', [Validators.required]);
  public loginForm!: UntypedFormGroup;
  public spinner$!: Observable<NgxSpinner>;
  public errorMessage = '';
  public loginErrorMessage = '';

  constructor() {
    this.loginForm = this.formBuilder.group({
      email: this.email,
      password: this.password
    });
  }

  ngOnInit(): void {
    this.spinner$ = this.spinnerService.spinnerObservable;
  }

  public async login(): Promise<void> {
    this.loginErrorMessage = '';
    this.errorMessage = this.getErrorMessage();
    if (!this.errorMessage) {
      await this.spinnerService.show();
      const login: IShopifyLogin = {
        email: this.email.value,
        password: this.password.value
      }
      const didSucceed = await this.customerService.loginWithPassword(login);
      this.googleAnalyticsService.eventEmitter('user_logged_in', 'Login', 'Login', 'Login', 1);
      await this.spinnerService.hide();

      if (!didSucceed) {
        this.loginErrorMessage = 'Invalid email or password'
      } else {
        this.customerService.closeDialog();
        await this.router.navigate(['/orders']);
      }
    }
  }

  public forgotPassword(): void {
    this.customerService.openForgotPassword();
  }

  public register(): void {
    this.customerService.openRegister();
  }

  private getErrorMessage(): string {
    if (this.email.hasError('required')) {
      return 'Please enter your email';
    } else if (this.password.hasError('required')) {
      return 'Please enter a password';
    }

    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

}
